import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function RegisterPage() {
  const { register } = useAuth();
  const [formData, setFormData] = useState({
    email: '',
    password: '',
    confirmPassword: '',
    schoolName: '',
    contactPerson: '',
    phone: '',
    adminCode: '',
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    if (formData.password !== formData.confirmPassword) {
      setError('Wachtwoorden komen niet overeen');
      return;
    }

    if (formData.password.length < 6) {
      setError('Wachtwoord moet minimaal 6 tekens zijn');
      return;
    }

    if (!isAdmin && !formData.schoolName) {
      setError('Vul de schoolnaam in');
      return;
    }

    setIsLoading(true);

    try {
      await register({
        email: formData.email,
        password: formData.password,
        schoolName: formData.schoolName || undefined,
        contactPerson: formData.contactPerson || undefined,
        phone: formData.phone || undefined,
        adminCode: isAdmin ? formData.adminCode : undefined,
      });
    } catch (err: any) {
      setError(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-card">
        <h2>📅 Account Aanmaken</h2>
        
        {error && <div className="error-message">{error}</div>}

        <div style={{ marginBottom: 20, display: 'flex', gap: 10 }}>
          <button
            type="button"
            className={`status-btn ${!isAdmin ? 'active' : ''}`}
            onClick={() => setIsAdmin(false)}
            style={{ flex: 1 }}
          >
            🏫 School
          </button>
          <button
            type="button"
            className={`status-btn ${isAdmin ? 'active' : ''}`}
            onClick={() => setIsAdmin(true)}
            style={{ flex: 1 }}
          >
            👤 Beheerder
          </button>
        </div>
        
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>E-mailadres *</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="uw@email.nl"
              required
            />
          </div>
          
          <div className="form-group">
            <label>Wachtwoord *</label>
            <input
              type="password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Minimaal 6 tekens"
              required
            />
          </div>
          
          <div className="form-group">
            <label>Bevestig wachtwoord *</label>
            <input
              type="password"
              name="confirmPassword"
              value={formData.confirmPassword}
              onChange={handleChange}
              placeholder="Herhaal wachtwoord"
              required
            />
          </div>

          {isAdmin ? (
            <div className="form-group">
              <label>Admin Code *</label>
              <input
                type="password"
                name="adminCode"
                value={formData.adminCode}
                onChange={handleChange}
                placeholder="Geheime admin code"
                required
              />
            </div>
          ) : (
            <>
              <div className="form-group">
                <label>Schoolnaam *</label>
                <input
                  type="text"
                  name="schoolName"
                  value={formData.schoolName}
                  onChange={handleChange}
                  placeholder="Naam van uw school"
                  required
                />
              </div>
              
              <div className="form-group">
                <label>Contactpersoon</label>
                <input
                  type="text"
                  name="contactPerson"
                  value={formData.contactPerson}
                  onChange={handleChange}
                  placeholder="Uw naam"
                />
              </div>
              
              <div className="form-group">
                <label>Telefoonnummer</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  placeholder="06-12345678"
                />
              </div>
            </>
          )}
          
          <button type="submit" className="btn btn-primary" disabled={isLoading}>
            {isLoading ? 'Registreren...' : 'Account Aanmaken'}
          </button>
        </form>
        
        <div className="auth-switch">
          Al een account? <Link to="/login">Inloggen</Link>
        </div>
      </div>
    </div>
  );
}
